<template>
  <div>
    <a href="#contenu-principal" class="skip">Passer au contenu principal</a>
    <header>
      <nav class="dashed-border-box ml-2 mr-3 d-flex float-left w-fit-content align-items-center px-3">
        <b-dropdown text="Menu" no-caret class="main-menu-btn mx-3 px-1 mt-1" boundary="viewport">
          <b-dropdown-item to="/">{{ LG("HP_homeButtonLabel") }}</b-dropdown-item>
          <b-dropdown-item to="/environment">{{ LG("HP_mapButtonLabel") }}</b-dropdown-item>
          <b-dropdown-item to="/bloc-notes">{{ LG("HP_blocnoteButtonLabel") }}</b-dropdown-item>
          <b-dropdown-item to="/plan-de-site">{{ LG("HP_planDeSiteButtonLabel") }}</b-dropdown-item>
          <b-dropdown-item to="/fiches-d-animation-de-communautes-d-apprentissage">Fiches d'animation de communautés d'apprentissage (CAP)</b-dropdown-item>
          <b-dropdown-item to="/ressources-pour-aller-plus-loin">Pour aller plus loin</b-dropdown-item>
          <b-dropdown-item to="/astuces">Astuces</b-dropdown-item>
          <b-dropdown-item to="/faq">Foire aux questions (FAQ)</b-dropdown-item>
        </b-dropdown>
        <AvatarIcon class="mr-3 ml-2" dropdown="yes"></AvatarIcon>
      </nav>

      <div class="dashed-border-box d-flex mx-2 parcour-info-box align-items-center">
        <div class="score-label parcour-label">
          {{ scoreLabelDisplay() }}
        </div>

        <div class="score-container stars-box">
          <div class="centered-element score-text">
            <span aria-hidden="true">{{ scoreDisplay() }}</span> <span class="sr-only">{{ scoreAriaLabel() }}</span>
          </div>
          <div class="score-stars d-flex flex-wrap justify-content-center">
            <div v-for="index in getStarCountAvailable()" :key="index">
              <div :class="getStarColor(index)">
                <span><font-awesome-icon icon="star"/></span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap progress-bars-box justify-content-center">
          <ProgressBar class="progress-bar-box" bar="0" headings="yes"></ProgressBar>
          <ProgressBar class="progress-bar-box" bar="1" headings="yes"></ProgressBar>
          <ProgressBar class="progress-bar-box" bar="2" headings="yes"></ProgressBar>
          <ProgressBar class="progress-bar-box" bar="3" headings="yes"></ProgressBar>
        </div>

        <button class="mute-button" v-on:click="onVolumeClicked()" :aria-label="getVolumeAriaLable()"><font-awesome-icon :icon="getVolumeIcon()" /></button>
      </div>
    </header>
    <div id="contenu-principal"></div>
  </div>
</template>

<script>
import AvatarIcon from "../components/AvatarIcon.vue";
import ProgressBar from "../components/ProgressBar.vue";

export default {
  name: "ProgressBars",
  props: {},
  components: {
    AvatarIcon,
    ProgressBar,
  },
  data() {
    return {};
  },
  mounted() {
    // TBD hack to turn off audio temporarily - REMOVE THIS ONCE WE KEEP AUDIO!!!
    if (!this.newVersion()) {
      this.muteAllAudio();
    }
  },
  computed: {},
  methods: {
    getStarColor(index) {
      if (index <= this.getStarCount()) {
        return "star-icon-completed";
      }
      return "star-icon-gray";
    },
    getStarCountAvailable() {
      var available = this.$store.state.gamestate.completed.length;
      return available;
    },
    getStarCount() {
      var available = this.$store.state.gamestate.completed.length;
      var count = 0;
      for (var i = 0; i < available; i++) {
        if (this.$store.state.gamestate.completed[i] == true) {
          count++;
        }
      }
      return count;
    },
    scoreLabelDisplay() {
      return this.LG("V2_score") + " :";
    },
    scoreDisplay() {
      return this.getStarCount() + "/" + this.getStarCountAvailable();
    },
    scoreAriaLabel() {
      return this.getStarCount() + " étoile sur " + this.getStarCountAvailable();
    },
    getVolumeIcon() {
      if (this.$store.state.gamestate.muted) {
        return "volume-mute";
      } else {
        return "volume-up";
      }
    },
    getVolumeAriaLable() {
      if (this.$store.state.gamestate.muted) {
        return "Activer le son";
      } else {
        return "Désactiver le son";
      }
    },
    onVolumeClicked() {
      if (!this.$store.state.gamestate.muted) {
        this.muteAllAudio();
        this.$store.commit("setMuted", true);
      } else {
        this.playRegisteredAudio();
        this.$store.commit("setMuted", false);
        this.unmuteAllMusic();
      }
      this.$emit("mute-clicked");

      this.saveGameState();
    },
  },
};
</script>

<style scoped>
.skip {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  background-color: #fff;
  padding: 5px 10px;
}
.skip:focus {
  position: absolute;
  top: 0;
  left: 0;
  left: initial;
  width: auto;
  height: auto;
}
.main-menu-btn::v-deep button {
  background-color: transparent;
  border: none !important;
  color: #154f68;
  background-image: url(../assets/icons/bars.png);
  background-size: calc(60px - 1.4rem);
  background-repeat: no-repeat;
  background-position: top center;

  display: inline-flex;
  align-items: flex-end;

  padding: 0;
  height: 60px;

  font-weight: 600;
}
.main-menu-btn::v-deep button:hover,
.main-menu-btn::v-deep button:focus,
.main-menu-btn::v-deep button:active,
.show::v-deep > .btn-secondary.dropdown-toggle {
  background-color: transparent !important;
  color: #0a0966 !important;
  background-image: url(../assets/icons/bars-hover.png);
}
.main-menu-btn::v-deep .dropdown-menu.show {
  border: solid 3px #154f68 !important;
  border-radius: 10px;
  /* width: 80%;
  max-width: 1120px; */
}

::v-deep .dropdown-menu {
  padding-top: 0;
  padding-bottom: 0;
}

::v-deep .dropdown-menu a {
  color: #07294e !important;
}

::v-deep .dropdown-menu a:hover,
::v-deep .dropdown-menu a:focus,
::v-deep .dropdown-menu a:active {
  background-color: #c8d9e0;
}

.dashed-border-box {
  border: 2px dashed #5f8699;
  background-color: #e8eff2;
  border-radius: 22px;
  min-height: 90px;
}

.w-fit-content {
  width: fit-content;
}
.parcour-info-box {
  min-width: 366px;
  padding-left: 10px;
  padding-right: 10px;
}

.parcour-label {
  max-width: 9.063rem;
  min-width: 5.188rem;
  width: 20%;
  padding-left: 1%;
  padding-right: 1%;
  text-align: center;
}
.stars-box {
  min-width: 3.75rem;
  max-width: 7.813rem;
  width: 20%;
  text-align: center;
  padding-left: 1%;
  padding-right: 1%;
}
.progress-bars-box {
  width: 100%;
  padding: 10px;
}
.progress-bar-box {
  min-width: 140px;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
}
@media (min-width: 808px) {
  .progress-bar-box {
    width: 50%;
  }
}
@media (min-width: 1184px) {
  .progress-bar-box {
    width: 25%;
  }
}
.mute-button {
  width: 60px;
  padding-left: 15px;
  padding-right: 15px;
}

.score-text {
  color: #154f68; /*#154F68;*/
  padding-top: 3px;
  font-size: 14px;
  font-weight: bold;
}

.score-label {
  color: #154f68;
  font-weight: bold;
}

.score-stars {
  padding-top: 0px;
}

.score-container {
  color: #ff6a00;
  text-align: center;
  font-size: 12px;
}

.mute-button {
  color: #154f68;
  background-color: transparent !important;
  border: none;
  font-size: 20px;
  text-align: center;
}

.mute-button:hover {
  /* outline: none !important; */
  color: darkblue;
}

.star-icon-gray {
  color: gray;
}

.star-icon-completed {
  color: orange;
}
</style>
